import { getJson, getString, invokeEvent, setJson } from 'shared-base';
import { experiments } from './experiments.data';
import { startExperiment } from './track';

const texturesResolution = getString('TEXTURE_RESOLUTION') || '256';
const savedSettings = getJson('SETTINGS') || {};
const bootstrapped = getJson('EXPERIMENTS') || {};

export const bootstrap = () => {
  const experimentValues: Record<string, any> = {};

  for (const exp of experiments) {
    if (exp.id in bootstrapped) {
      continue;
    }

    const variant = getExperimentValue(exp);
    if (!variant) {
      invokeEvent('sentry', { err: `Experiment ${exp.id} (${exp.name}) has no variants` });
      continue;
    }
    if (!variant) continue;

    startExperiment(exp.id, variant.id);
    experimentValues[exp.id] = variant.value;
    console.log(`Experiment ${exp.id} (${exp.name}) => ${variant.value}`);
  }

  const output: ISettings = {
    sortGeneratorsById: false,
    whiteThumbnails: true,
    texturesResolution: texturesResolution as TexturesResolution,
    openAiKey: '',
    ...savedSettings,
    ...experimentValues,
  };

  setJson('EXPERIMENTS', experimentValues);
  setJson('SETTINGS', output);

  return output;
};

function getExperimentValue(experiment: IExperiment): any {
  const variants = Object.values(experiment.variants);
  if (variants.length === 0) return null;

  const rand = Math.random();
  let cumulative = 0;

  for (const variant of variants) {
    cumulative += variant.percent;
    if (rand <= cumulative) {
      return variant;
    }
  }

  // Normalize in case total percent is < 1
  return variants[0];
}
